import { useSelector } from 'react-redux';

const useCustomSelector = (selector) =>
  useSelector(
    selector,
    (oldValue, newValue) => JSON.stringify(oldValue) === JSON.stringify(newValue),
  );

export default useCustomSelector;
